<div class="iframe-container">
  <div class="center-text">
    {{ agentName }}
    <app-resize-buttons></app-resize-buttons>
  </div>

  <div class="cxone-agent-container" id="launchCXA">Carregando Iframe...</div>
</div>
